// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"38ee194f","4482":"ab085610","5589":"38ee194f","7898":"38ee194f"}[chunkId] + ".chunk.css";
};